'use client';
import { blend } from '../../../modules/colors/impl/blend/blend.js';

var ratio = {
    hover: {
        primary: {
            day: 0.15,
            night: 0.15
        },
        info: {
            day: 0.04,
            night: 0.1
        }
    },
    active: {
        primary: {
            day: 0.3,
            night: 0.3
        },
        info: {
            day: 0.08,
            night: 0.15
        }
    }
};
var deriveStates = function(theme) {
    return function(color, overlay) {
        var mixture = theme.palette.mixture;
        var mode = theme.mode;
        return {
            hover: blend(color, mixture[overlay], ratio.hover[overlay][mode]),
            active: blend(color, mixture[overlay], ratio.active[overlay][mode])
        };
    };
};

export { deriveStates };
